<template>
  <v-container
    v-if="$store.getters.loadingApp !== 1"
    style="max-width: 100%"
  >
    <v-data-table
      :headers="headers"
      :items="updatedAvailableProjects"
      class="elevation-1"
      :items-per-page="-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>Projects</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <v-btn
            color="ppc_pink"
            dark
            small
            absolute
            right
            fab
            @click="dialog=true"
          >
            <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
          </v-btn>
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
          >
            <v-form ref="dialogForm">
              <v-card>
                <v-card-title class="ppc_darkgreen darken-1">
                  <span class="headline white--text">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-text-field
                        v-model.trim="editedItem.name"
                        label="Name"
                        counter="45"
                        :rules="inputRulesName"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-select
                        v-model="editedItem.category_id"
                        :items="$store.state.projectCategories"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ auto: true }"
                        label="Select category"
                        single-line
                        validate-on-blur
                      />
                    </v-col>
                    <v-radio-group
                      v-model="editedItem.type"
                      cols="12"
                      column
                      class="mt-0 mx-2"
                    >
                      <v-radio
                        label="Volunteering"
                        value="Volunteering"
                        class="my-0 py-0"
                      />
                      <v-radio
                        label="Internship"
                        value="Internship"
                        class="my-0 py-0"
                      />
                    </v-radio-group>
                    <v-col
                      cols="12"
                    >
                      <v-textarea
                        v-model="editedItem.description"
                        class="rounded-xl ma-3"
                        auto-grow
                        clearable
                        counter="500"
                        outlined
                        label="Description (500 max)"
                        :rules="[v => (v || '' ).length <= 500 || 'Comments must be 500 characters or less']"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="d-flex flex-row flex-wrap py-0 my-0"
                    >
                      <v-col 
                        cols="12"
                        sm="6"
                        md="4"
                        class="py-0 my-0"
                      >
                        <v-checkbox
                          :input-value="editedItem.obsolete !== null"
                          label="Obsolete"
                          @change="setObsolete($event)"
                        />
                      </v-col>
                      <v-col 
                        cols="12"
                        sm="6"
                        md="4"
                        class="py-0 my-0"
                      >
                        <v-text-field
                          v-if="editedItem.obsolete !== null"
                          :value="formattedDate(editedItem.obsolete)"
                          disabled
                          label="From"
                          class="ml-2"
                        />
                      </v-col>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    />
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="ppc_darkgreen darken-1"
                    text
                    @click="close"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="ppc_darkgreen darken-1"
                    text
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <v-card-title>Are you sure you want to delete {{ editedItem.name }}?</v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="closeDelete"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  OK
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.obsolete`]="{ item }">
        <v-icon
          v-if="item.obsolete !== null"
          small
          color="ppc_pink"
        >
          $vuetify.icons.icon_mdi_cancel
        </v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          $vuetify.icons.icon_mdi_pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          $vuetify.icons.icon_mdi_delete
        </v-icon>
      </template>
    </v-data-table>
    <v-divider />
    <div class="d-flex flex-row mb-7">
      <v-spacer />
      <v-btn
        color="ppc_darkgreen darken-1"
        text
        @click="$router.go(-1)"
      >
        Ok
      </v-btn>
    </div>
  </v-container>
</template>

<script>

import dayjs from 'dayjs';
import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';

export default {

    mixins: [inputRules, formattedDate],
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Category', value: 'category' },
        { text: 'Type', value: 'type' },
        { text: 'Description', value: 'description' },
        { text: 'Obsolete', value: 'obsolete' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      updatedAvailableProjects: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        category_id: 1,
        type: 'Volunteering',
        description: null,
        obsolete: null,
      },
      defaultItem: {
        name: '',
        category_id: 1,
        type: 'Volunteering',
        description: null,
        obsolete: null,
      },
    }),

    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'New Project' : 'Edit Project'
        },
    },

    watch: {
    },

    beforeCreate () {
        if (this.$store.state.accessProjects === 0) {
            this.$router.push({ name: 'Illegal' })
        }
        this.$store.dispatch('setLoadingApp', 1)
    },

    created () {
      this.initialize()
    },

    methods: {
        async initialize () {
            await this.$store.dispatch('getProjects');
            this.updatedAvailableProjects = JSON.parse(JSON.stringify(this.$store.state.projects));
            for (let index = 0; index < this.updatedAvailableProjects.length; index++) {
                (this.updatedAvailableProjects[index].obsolete) ? this.updatedAvailableProjects[index].obsolete = this.formattedDate(this.updatedAvailableProjects[index].obsolete, 'date') : this.updatedAvailableProjects[index].obsolete = null;
            }
            let breadcrumb =  JSON.parse(JSON.stringify(this.$store.state.breadcrumbs));
            breadcrumb.push('Projects');
            await this.$store.dispatch('breadcrumbs', breadcrumb);
            this.$store.dispatch('setLoadingApp', 0)
        },

        editItem (item) {
            this.editedIndex = this.updatedAvailableProjects.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        deleteItem (item) {
            this.editedIndex = this.updatedAvailableProjects.indexOf(item)
            this.editedItem = Object.assign({}, item)
            let tmp = this.editedItem.id;
            let usedProjects = this.$store.state.projectPlacements.filter(function(select_item) {
                    return select_item.project_id === tmp;
                }
            )
            if (usedProjects.length > 0) {
                this.$store.dispatch('errorMessage', 'The project "' + this.editedItem.name + '" is still in use with ' + usedProjects[0].name);
                return;
            } else {
                this.dialogDelete = true
            }
        },

        async deleteItemConfirm () {
            let response = await this.$store.dispatch('deleteProject', this.editedItem.id);
            if (response.data.affectedRows === 1) {
                this.$store.dispatch('successMessage', 'Project deleted');
            } else {
                this.$store.dispatch('errorMessage', 'Something went wrong');
            }
            await this.$store.dispatch('getProjects');
            this.updatedAvailableProjects = JSON.parse(JSON.stringify(this.$store.state.projects));
            this.closeDelete()
        },

        setObsolete(event) {
            if (event) {
                this.editedItem.obsolete = dayjs().format("YYYY-MM-DD")
            } else {
                this.editedItem.obsolete = null
            }
            
        },

        close () {
            this.dialog = false
            this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            })
        },

        closeDelete () {
            this.dialogDelete = false
            this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            })
        },
        async save () {
            if(this.$refs.dialogForm.validate()){
                let tmp = this.editedItem.name;
                let doubleName = this.updatedAvailableProjects.filter(function(select_item) {
                        return select_item.name === tmp;
                    }
                )
                if (doubleName.length > 0 && this.editedIndex !== this.updatedAvailableProjects.indexOf(doubleName[0])) {
                    this.$store.dispatch('errorMessage', 'The name "' + this.editedItem.name + '" is already in use!');
                    return;
                } else {
                    await this.$store.dispatch('insertProject', this.editedItem);
                    await this.$store.dispatch('getProjects');
                    this.updatedAvailableProjects = JSON.parse(JSON.stringify(this.$store.state.projects));
                }
                this.close()
            }
        },
    },
  }

</script>

<style>
    .v-card__title {
        color: #35b729;
        word-break: normal !important;
    }
    .v-card__subtitle { padding-top: 0; padding-bottom: 0;}
    .pos_absolute {
        position: absolute;
    }
</style>